import React, { useMemo } from 'react';
import Image from 'frontastic/lib/image';
import Slider from 'components/commercetools-ui/atoms/slider';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
import useTouchDevice from 'helpers/hooks/useTouchDevice';
import { mediumDesktop, tablet } from 'helpers/utils/screensizes';

import { GenericSectionContent, MediaCard } from '../../types';
import { useAdditionalCss } from '../../../helpers/useAdditionalCss';
import styles from './index.module.css';

export default function VegaRendering({ content }: { content: GenericSectionContent }) {
  const { cards, additional_css, additional_css_class_names } = content;

  const { uniqueClass, scopedAdditionalCss } = useAdditionalCss(additional_css, 'VegaRendering');

  const { isTouchDevice } = useTouchDevice();

  const [isDesktopSize] = useMediaQuery(mediumDesktop);
  const [isTabletSize] = useMediaQuery(tablet);
  const showArrows = useMemo(
    () =>
      !isTouchDevice && !((isDesktopSize && cards?.length <= 4) || (!isDesktopSize && cards?.length <= 2)),
    [isDesktopSize, isTouchDevice, cards?.length],
  );

  return (
    <>
      {scopedAdditionalCss && <style dangerouslySetInnerHTML={{ __html: scopedAdditionalCss }} />}
      <div className={`hero-slider-container w-full pt-24 pb-24 lg:pt-40 lg:pb-40 2xl:pt-60 2xl:pb-60 ${[additional_css_class_names, uniqueClass].filter(Boolean).join(' ')}`}>
        <Slider
          slidesPerView={isTabletSize ? 1.3 : 1}
          dots={true}
          spaceBetween={16}
          arrows={isTabletSize}
          innerArrows
          allowArrowsOnTouchDevice
          allowTouchMove={true}
          prevButtonStyles={{ padding: '15px', left: '0px' }}
          nextButtonStyles={{ padding: '15px', right: '0px' }}
          autoplay={{
            delay: 2000,
            disableOnInteraction: false,
          }}
        >
          {cards?.map((slide: MediaCard, index: number) => (
            <div className="relative h-[18rem] md:h-[34rem] 2xl:h-[44rem]" key={index}>
              {slide?.desktop_image?.url ? (
                <Image
                  loading='lazy'
                  src={slide?.desktop_image?.url}
                  alt={slide?.desktop_image?.description ?? ''}
                  fill
                  style={{ objectFit: 'cover' }}
                />
              ) : (
                <div className="flex-1"></div>
              )}
            </div>
          ))}
        </Slider>
      </div>
    </>
  );
}
